import gql from 'graphql-tag';

export const VISIT_WITH_ORGANIZATION_FIELDS = gql`
  fragment VisitWithOrganizationFields on OdProtosTrippyData_Visit {
    id
    assignedOrganizationToken
    assignedOrganization {
      members {
        userToken
        user {
          fullName
        }
      }
    }
  }
`;
